import { makeVar } from '@apollo/client'

import { MatchedPlaceFragment, Maybe, VisitSubProofInput, Menu, PostReceiptVisitDateTime } from '@web/gql/graphql'

import { receiptVar } from '../../receipt/index.state'

/** typename을 제외한 Fragment타입 추출 */
type ExtractFragmentType<T> = T extends Maybe<{ __typename?: string }>
  ? ExtractFragmentType<Omit<T, '__typename'>>
  : T extends Array<Maybe<{ __typename?: string } & infer E>>
  ? Array<ExtractFragmentType<E>>
  : T

export type MatchedPlaceVar = ExtractFragmentType<MatchedPlaceFragment>
type VisitDateTime = Pick<PostReceiptVisitDateTime, 'date' | 'time'>
const initialVisitDateTime: VisitDateTime = { date: null, time: null }

export const createVisitVar = {
  matchedPlaces: makeVar<MatchedPlaceVar[]>([]),
  totalPrice: makeVar<number | null>(null),
  visitDateTime: makeVar<VisitDateTime>(initialVisitDateTime),
  proof: makeVar<VisitSubProofInput | null>(null),
  selectedPlace: makeVar<MatchedPlaceVar | null>(null),
  searchText: makeVar<string | null>(null),
  menus: makeVar<Menu[]>([]),
}

export const resetCreateVisitVar = () => {
  createVisitVar.matchedPlaces([])
  createVisitVar.totalPrice(null)
  createVisitVar.visitDateTime(initialVisitDateTime)
  createVisitVar.proof(null)
  createVisitVar.selectedPlace(null)
  createVisitVar.searchText(null)
  createVisitVar.menus([])
  receiptVar(undefined)
}

export enum MatchedPlaces {
  SINGLE = 'single',
  MULTIPLE = 'multiple',
  NONE = 'none',
  SEARCH = 'search',
}

export enum VisitNotice {
  MAX_PROOF = 'maxProof',
}

/** 방문생성 장소매칭 */
export const VISIT_NEW_QUERY_KEY = 'matched'

/** 방문생성 영수증 뷰 */
export const RECEIPT_VIEW_QUERY_KEY = 'receiptId'

/** 방문엔드 인증추가 툴팁  */
export const VISIT_ADD_PROOF_QUERY_KEY = 'detail'

/** 방문엔드 팝업 타입 */
export const VISIT_NOTICE = 'notice'

/** 방문 증거 타입 */
export const VISIT_NEW_TYPE = 'type'

/** 검색 인입 출처 */
export const VISIT_NEW_SEARCH_FROM = 'from'
